export const extractTaskStatus = jsonLd => {
  const taskStatus = jsonLd['atlassian:taskStatus'];
  if (taskStatus && taskStatus.name) {
    return {
      text: taskStatus.name,
      appearance: 'success'
    };
  }
};